import type { SellerProductInventoriesForBuyerFilters } from '~/api/inventory';
import { DeliveryMode } from '~/graphql/graphql';

// Seller rows span every facility, so no delivered price exists; tally rows show pickup to match.
export function buildComparisonInventoryFilters(
  filters: Omit<SellerProductInventoriesForBuyerFilters, 'deliveryMode'>
): SellerProductInventoriesForBuyerFilters & { deliveryMode: DeliveryMode } {
  return { ...filters, deliveryMode: DeliveryMode.Pickup };
}
